{
  "id": "melee",
  "role": "melee",
  "speed": 80,
  "cost": {
    "gold": 60,
    "lumber": 0
  },
  "trainTicks": 120,
  "supply": 1,
  "hp": 60,
  "builds": [],
  "combat": {
    "damage": 8,
    "range": 1,
    "cooldownTicks": 20,
    "acquireRange": 5
  }
}
